import { useCallback, useEffect, useState } from 'react';
import { getCurrentUserFromJwt } from '../helpers/jwt-helper';
export function currentActorId() {
    try {
        return getCurrentUserFromJwt()?.id || '';
    }
    catch {
        return '';
    }
}
// Axios obtains its token at request time. A mounted form must never silently
// become a different account's form when another tab changes that token.
export function useActorBoundary() {
    const [actor] = useState(currentActorId);
    const [changed, setChanged] = useState(false);
    const check = useCallback(() => {
        const valid = !!actor && actor === currentActorId();
        if (!valid)
            setChanged(true);
        return valid;
    }, [actor]);
    useEffect(() => {
        const onStorage = () => { check(); };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, [check]);
    const read = async (request) => {
        if (!check())
            throw new Error('Account changed; reload required.');
        const result = await request();
        if (!check())
            throw new Error('Account changed; reload required.');
        return result;
    };
    return { actor, changed, check, read };
}
